<template>
  <div v-if="!isLoading">
    <medication-line-graph
      v-if="$store.state.user.scope"
      class="insetGraph">
    </medication-line-graph>
    <mu-row class="content" gutter v-if="$store.state.user.scope">
      <mu-col desktop="30" tablet="50" width="100">
        <medication-input style="margin-top: 24px"></medication-input>
        <tracking-notifier
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50" width="100">
        <mu-card style="margin-top: 24px;" id="blood-glucose-data" class="tracking-data">
          <mu-card-text>
            <p class="tracking-subtext" v-text="$t('message.trackingHelpText')"></p>
          </mu-card-text>
          <mu-timeline>
            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" :key="'title-index-' + titleIndex" v-if="titleIndex === 0"
                   class="timelineSpacing">
                <div class="bold timelineTitle groupedDate"
                     v-text="groupedDateFormat(titleItem.date_created)">
                </div>
              </div>
              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index" v-bind:class="{notEditMode: !item.isEditMode}">
                <mu-timeline-item
                  :iconColor="btnColor"
                  iconLine="8"
                  iconType="solid"
                  @click.native="showItemControls(item)"
                >
                  <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}">
                    <mu-row>
                      <mu-col>
                        <div class="trackingDate" v-if="!item.isEditMode"
                             v-text="groupedItemDate(item.date_created)"></div>
                        <div>{{item.treatment_name}}</div>
                      </mu-col>
                      <mu-col>
                        <div v-if="!item.isEditMode" class="reading">
                          {{item.dosage + ' ' + localizeRegime(item.unit_label)}}
                        </div>
                      </mu-col>
                    </mu-row>
                  </div>
                  <div v-if="item.isControlsVisible === true && !item.isEditMode">
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.editText')"
                      icon="edit"
                      @click.native="editReading(item)"
                    >
                    </mu-flat-button>
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.deleteText')"
                      icon="delete"
                      @click.native="deleteReading(item)"
                    ></mu-flat-button>
                  </div>
                  <div v-if="item.isEditMode">
                    <medication-edit
                      :item="item"
                      @updateReading="updateReading"
                      @closeEditPanel="closeEditMode(item)"
                    ></medication-edit>
                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div v-text="$t('message.loadingText')"></div>
          </mu-card-text>
          <div v-if="!isReadingsLoading" ref="detector"></div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>
  import MedicationLineGraph from "../../components/Tracking/Graphs/Medication/LineGraph";
  import MedicationApi from "../../api/Tracking/Medication"
  import MedicationInput from "../../components/Tracking/Input/Medication/Medication";
  import TrackingDetailMixin from "../../mixins/TrackingDetailMixin"
  import MedicationRegimeMixin from '../../mixins/Localization/MedicationRegimes';
  import MedicationEdit from "../../components/Tracking/Edit/Medication/MedicationEdit";
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";

  export default {
    mixins: [
      TrackingDetailMixin,
      MedicationRegimeMixin
    ],
    components: {
      TrackingNotifier,
      MedicationEdit,
      MedicationInput,
      MedicationLineGraph
    },
    data() {
      return {
        btnColor: '#AE3463',
        isLoading: true,
        activeTrackingId: 0,
        medications: []
      }
    },
    mounted() {
      let self = this;
      self.loadData();

      self.$EventBus.$on('medicationPusherReceived', function () {
        self.loadData();
      })

      MedicationApi.getUserMedications()
        .then(function (response) {
          self.medications = response.data;
          self.setActiveMedicationByIndex(0);
          self.$nextTick(function () {
            self.isLoading = false;
          });
        })
    },
    methods: {
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          MedicationApi.getMedicationsTrackingDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      },
      loadData() {
        let self = this;
        MedicationApi.getMedicationsTrackingDetail(1, 15)
          .then(function (response) {
            self.data = response.data;
            self.isReadingsLoading = false;
          });
      },
      deleteReading(reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveMedicationItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return MedicationApi.deleteMedicationDosage(reading.dosage_id)
          }
        })
          .then(function () {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedRemoveMedicationItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })
          }.bind(self))
          .catch(self.$alert.noop)
      },
      updateReading(item) {
        let self = this;
        let currentReading = self.data.data.filter(function (dosage) {
          return dosage.dosage_id === item.dosage_id
        })[0];
        currentReading.dosage = item.dosage;
        currentReading.date_created = item.date_created;
        currentReading.isEditMode = false;

        self.sortItems();

      },
      setActiveMedicationByIndex(index) {
        let self = this;
        self.activeTrackingId = self.medications[index].tracking_id;
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('medicationPusherReceived');
      this.$EventBus.$off('medicationReadingAdded')
    }
  }
</script>



// WEBPACK FOOTER //
// Medication.vue?17ecf7ee